import View from './view';

export { componentName } from 'src/components/sorter-rule/const';
export default View;
